import { useModal } from '../../../../contexts/modalsContext/modalsContext';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import './AuthDrawer.scss';
import SocialAuthButtons from '../../modals/registerModal/components/SocialAuthButtons';
import AuthorizeForm from '../../../forms/authorize/AuthorizeForm';
import useTranslation from '../../../../hooks/translation/useTranslation';
import DefaultDrawer from '../defaultDrawer/DefaultDrawer';

function AuthDrawer({
  form,
  loading,
  errors,
  handleSubmit,
  handleNotRegistered,
}) {
  const { trans, configInfo } = useTranslation();
  const { width } = useWindowDimensions();
  const { showAuthModal, setShowAuthModal } = useModal();

  const isGeorgia = configInfo?.countryCode === 'GE';

  return (
    <DefaultDrawer
      placement="bottom"
      setShow={setShowAuthModal}
      show={showAuthModal && width < 1024}
      className="gray-after auth-drawer media"
      style={{
        backgroundColor: '#f1f2f6',
      }}
    >
      <div className="flex flex-col gap-[30px]">
        <div className="flex flex-col gap-1">
          <span className="text-xs font-bold">
            {trans('still_not_authorized')}
          </span>
          <button
            type="button"
            className="bg-transparent border-0 text-base text-primary font-bold cursor-pointer w-fit p-0"
            onClick={handleNotRegistered}
          >
            {trans('registration').toLocaleUpperCase()}
          </button>
        </div>
        <div className="flex flex-col gap-5">
          <h2 className="text-2xl font-bold">{trans('authorization').toLocaleUpperCase()}</h2>
          {isGeorgia && (
          <>
            <SocialAuthButtons />
            <div className="line-container">
              <span className="text-center text-grGrey text-sm">{trans('or')}</span>
            </div>
          </>
          )}
          <AuthorizeForm
            form={form}
            loading={loading}
            errors={errors}
            handleSubmit={handleSubmit}
          />
        </div>
      </div>
    </DefaultDrawer>
  );
}

export default AuthDrawer;
